import AutoplayController from "~/lib/autoplay_controller"
import { money, replay, tween } from "~/lib/motion"

// Home hero: both apps on one storefront. The bundle offer lights up on the
// product page (Bundles app), the shopper adds it, the add-to-cart upsell
// popup appears (UpSell app) and they take the AI pick. The order value grows.
export default class extends AutoplayController {
  static targets = ["offer", "bundleLabel", "bundleButton", "count", "total", "popup", "offerButton", "toast"]

  reset() {
    this.offerTarget.classList.remove("is-applied")
    this.bundleLabelTarget.hidden = true
    this.popupTarget.hidden = true
    this.offerButtonTarget.classList.remove("is-done")
    this.offerButtonTarget.textContent = "Add"
    this.countTarget.textContent = "0"
    this.totalTarget.textContent = money(35)
    this.toastTarget.hidden = true
  }

  async play(wait) {
    await wait(700)
    this.offerTarget.classList.add("is-applied")
    this.bundleLabelTarget.hidden = false
    replay(this.bundleLabelTarget, "is-pop")

    await wait(1100)
    await this.click(this.bundleButtonTarget, wait)
    this.setCount(2)
    tween(this.totalTarget, 35, 45, 500)

    await wait(600)
    this.popupTarget.hidden = false
    replay(this.popupTarget, "is-pop")

    await wait(1200)
    await this.click(this.offerButtonTarget, wait)
    this.offerButtonTarget.classList.add("is-done")
    this.offerButtonTarget.textContent = "Added ✓"
    this.setCount(3)
    tween(this.totalTarget, 45, 56.9, 500)

    await wait(1100)
    this.popupTarget.hidden = true
    this.toastTarget.hidden = false
    replay(this.toastTarget, "is-pop")
  }

  setCount(count) {
    this.countTarget.textContent = String(count)
    replay(this.countTarget, "is-bump")
  }
}
